import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router'
import cx from 'classnames'
import classes from '../List.scss'

import ListItemColumn from './Column'

export const ListItem = (props) => {
  const className = cx({
    [classes['list-item']]: classes['list-item'],
    [classes['list-item--link']]: !!props.link,

    [classes['list-item--disabled']]: !!props.disabled,
    [classes['list-item--alwaysLink']]: !!props.alwaysLink
  })

  const onClick = () => props.link && (!props.disabled || props.alwaysLink) ? props.router.push(props.link) : false

  return (
    <tr className={className} onClick={onClick}>
      {!!props.data.length && props.data.map((child, index) => {
        // data = [ '', [''], ... ]
        const options = props.options && props.options[index]

        if (Array.isArray(child)) {
          return (
            <ListItemColumn key={index} {...options}>
              {child.filter(row => !!row)
                .map((row, _index) => <span className={classes['list-item--row']} key={_index}>{row}</span>)
              }
            </ListItemColumn>
          )
        }

        return <ListItemColumn key={index} {...options}>{child}</ListItemColumn>
      })}
    </tr>
  )
}

ListItem.propTypes = {
  router: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  options: PropTypes.array, // this is an array of options relative to data
  link: PropTypes.string,

  disabled: PropTypes.bool,
  alwaysLink: PropTypes.bool
}

ListItem.defaultProps = {
  options: {},
  disabled: false
}

export default withRouter(ListItem)



// WEBPACK FOOTER //
// ./src/components/List/Item/ListItem.js